export enum USER_ADMIN_MODULES {
  USER_ADMIN = 'USER_ADMIN',
  WELL_GROUPS = 'WELL_GROUPS',
}

export const userAdminModules = Object.values(USER_ADMIN_MODULES);
